import { useRouter } from 'next/router';
import { classNames } from '@farawaygg/utils-lotm';
import { twMerge } from 'tailwind-merge';
import { useEffect, useState } from 'react';
import { Link } from '@packages/common-ui/components/link';
import { OthersideLogo } from '@packages/common-ui/components/logo/otherside-logo';
import { useBreakpoint } from '@packages/common-ui/hooks/use-breakpoint';
import { FarawayLogo } from '@packages/common-ui/components/icons/faraway';
import { getAssetPrefix, getDomainIdentifier } from '@packages/common-ui/utils/environmentUtils';
import { NavLink } from '@packages/common-ui/types/navigation';
import { getFooterLinks, logoFooterLinks, lotmDecouplingFooterLinks, socialFooterLinks } from './footer-routes';
const currentYear = new Date().getFullYear();
const LegalLinks = () => {
  const [finalRoutes, setFinalRoutes] = useState<NavLink[]>([]);

  /* Avoids hydration error, because window is not defined on server side */
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const domainIdentifier = getDomainIdentifier(window.location.origin);
      const footerLinks = getFooterLinks(domainIdentifier);
      if (domainIdentifier === 'lotm' && window.location.pathname === '/expanded') {
        setFinalRoutes(lotmDecouplingFooterLinks);
        return;
      }
      setFinalRoutes(footerLinks);
    }
  }, []);
  return <ul className="mt-8 w-full space-y-2 text-center sm:flex sm:justify-center sm:space-x-6 sm:space-y-0 md:my-0 md:w-auto md:justify-start  md:space-x-4">
      {finalRoutes.map(({
      domain,
      href,
      label
    }) => <li key={href}>
          <Link domain={domain} href={href} className="footer-text mt-1 inline-block whitespace-nowrap border-b border-gray-light pb-1 uppercase">
            {label}
          </Link>
        </li>)}
    </ul>;
};
const Copyright = () => <span className="footer-text mb-0 mt-8 block whitespace-nowrap text-center uppercase md:mb-0 md:mt-0 md:text-left">
    © {currentYear} Faraway Inc.
  </span>;
const SocialLinks = () => <ul className="mt-14 flex items-center space-x-5 pt-[2px] md:mt-0 md:justify-end">
    {socialFooterLinks.map(({
    href,
    Icon,
    label
  }) => <li key={href}>
        <a href={href} target="_blank" rel="noreferrer" className="flex h-5 items-center justify-center text-gray-light md:h-3">
          <span className="sr-only">{label}</span>
          <Icon />
        </a>
      </li>)}
  </ul>;
interface Props {
  className?: string;
  inNav?: boolean;
  showImprobable?: boolean;
  showBgEffect?: boolean;
}
export const Footer = ({
  className,
  inNav,
  showImprobable = true,
  showBgEffect = false
}: Props) => {
  const router = useRouter();
  const aboveMobile = useBreakpoint('md');
  const bgStyle = showBgEffect ? {
    backgroundImage: `url(${getAssetPrefix('/footer/footerBg.webp')})`
  } : {};
  return <footer className={twMerge('relative h-auto w-screen pt-36 font-cta text-gray-light md:w-full', router.pathname === '/' && 'home-footer', inNav ? '-mx-5' : 'px-0', showBgEffect && 'bg-[url(/assets/vessel-hatching/footerBg.webp)] bg-cover bg-center', className)} style={bgStyle}>
      <div className={classNames('relative mx-auto flex w-full max-w-screen-xl flex-col items-center text-[8px] md:w-[600px] lg:w-1/2', inNav && 'px-5')}>
        <div className="flex w-full max-w-sm items-center justify-center space-x-6 text-white md:mb-10 md:space-x-12">
          <a href={logoFooterLinks.faraway} target="_blank" rel="noreferrer noopener">
            <span className="sr-only">Faraway</span>
            <FarawayLogo className="h-5 md:h-7" />
          </a>
        </div>
        {aboveMobile ? <div className="flex w-full items-center justify-center md:space-x-12">
            <Copyright />
            <LegalLinks />
            <div className="flex items-center justify-end">
              <SocialLinks />
            </div>
          </div> : <>
            <SocialLinks />
            <div className="w-full px-3">
              <LegalLinks />
            </div>
            <Copyright />
            <div className="-mx-12 mt-8 h-[calc(30vw_-_45px)] w-screen overflow-hidden">
              <OthersideLogo className="w-screen" />
            </div>
          </>}
      </div>
      {aboveMobile && <div className="mt-6 h-[15vw] w-full overflow-hidden sm:mt-12">
          <OthersideLogo className="relative w-full" />
        </div>}
    </footer>;
};